const numberOrNull = (value) => {
    if (value === null || value === undefined || `${value}`.trim() === '') return null
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : null
}

const firstPresent = (...values) => values.find((value) => value !== undefined && value !== null && `${value}`.trim() !== '')

const normalizeItem = (item = {}) => ({
    id: `${firstPresent(item.item_id, item.id, item.ms_item_id, item.item_slug, item.slug) || ''}`,
    quantity: numberOrNull(firstPresent(item.quantity, item.qty)) || 0,
    price: numberOrNull(firstPresent(item.current_price, item.price, item.item_price))
})

const unwrapPreview = (payload) => {
    let current = payload
    for (let index = 0; index < 3; index += 1) {
        if (!current || typeof current !== 'object' || Array.isArray(current)) return {}
        if (current.summary && typeof current.summary === 'object') {
            return { ...(current.marketplace_preview || {}), ...current.summary }
        }
        if (
            current.transaction_amount !== undefined ||
            current.transaction_total_amount !== undefined ||
            Array.isArray(current.current_order)
        ) return current
        if (!current.data || typeof current.data !== 'object' || Array.isArray(current.data)) return current
        current = current.data
    }
    return current || {}
}

export const checkoutPreviewSummary = (payload) => {
    const preview = unwrapPreview(payload)
    const items = Array.isArray(preview.current_order)
        ? preview.current_order
        : Array.isArray(preview.item)
            ? preview.item
            : []

    return {
        items: items.map(normalizeItem),
        subtotal: numberOrNull(firstPresent(preview.transaction_amount, preview.subtotal, preview.amount)),
        discount: numberOrNull(firstPresent(preview.transaction_discount, preview.discount_amount, preview.discount)),
        shipping: numberOrNull(firstPresent(preview.transaction_shipping_fee, preview.shipping_fee, preview.shipping_amount)),
        total: numberOrNull(firstPresent(preview.transaction_total_amount, preview.total_amount, preview.grand_total)),
        shippingService: `${firstPresent(preview.shipping_service, preview.shipping_service_detail?.shipment_method, preview.shipping_service_detail?.service) || ''}`.trim(),
        deliveryId: `${firstPresent(preview.ms_delivery_id, preview.delivery_id) || ''}`.trim(),
        voucherCode: `${firstPresent(preview.voucher_code, preview.voucher_loyalty?.voucher_code) || ''}`.trim()
    }
}

export const localCheckoutSummary = ({ carts = [], subtotal, discount, shipping, total, shippingService, deliveryId, voucherCode }) => ({
    items: carts.map(normalizeItem),
    subtotal: numberOrNull(subtotal),
    discount: numberOrNull(discount),
    shipping: numberOrNull(shipping),
    total: numberOrNull(total),
    shippingService: `${shippingService || ''}`.trim(),
    deliveryId: `${deliveryId || ''}`.trim(),
    voucherCode: `${voucherCode || ''}`.trim()
})

const sameNumber = (left, right) => left === null || right === null || left === right

export const compareCheckoutPreview = (local, server) => {
    const differences = []
    ;[
        ['subtotal', 'subtotal'],
        ['discount', 'diskon'],
        ['shipping', 'biaya pengiriman'],
        ['total', 'total pembayaran']
    ].forEach(([field, label]) => {
        if (!sameNumber(local[field], server[field])) differences.push(label)
    })

    if (server.items.length > 0) {
        const localItems = local.items.map((item) => `${item.id}:${item.quantity}:${item.price ?? ''}`).sort()
        const serverItems = server.items.map((item) => `${item.id}:${item.quantity}:${item.price ?? ''}`).sort()
        if (localItems.join('|') !== serverItems.join('|')) differences.push('item pesanan')
    }
    if (server.shippingService && local.shippingService && server.shippingService !== local.shippingService) differences.push('jasa pengiriman')
    if (server.deliveryId && local.deliveryId && server.deliveryId !== local.deliveryId) differences.push('metode pengiriman')
    if (server.voucherCode && local.voucherCode && server.voucherCode !== local.voucherCode) differences.push('voucher')

    return { matches: differences.length === 0, differences }
}
